import { PROGRAM_TYPE, ROUTE_CONSTANT } from '../../../config/constants';
import url from '../../../helpers/url';

export {
    trackQuickActionMenuOpened,
    trackQuickActionMenuDismissed,
    trackQuickActionClicked,
    getQuickActionFailureReason,
} from './mixpanel';
export type { QuickActionName, QuickActionResult } from './mixpanel';
export {
    isTaContinueWatchingCarousel,
    TA_CONTINUE_WATCHING_WCP_TYPE,
    BOOKMARK_CONTINUE_WATCHING_WCP_TYPE,
} from './taContinueWatch';

export const getLinearContinueWatchRoute = (item: any) =>
    url.route(url.getDetailsPage('live'), {
        listingId: btoa(item?.listing?.id),
        startDate: btoa(new Date(item?.listing?.startTime).getTime().toString()),
        ...(Number(item?.timeCode) > 0 && { timeCode: btoa(String(item.timeCode)) }),
    });

export const getVodContinueWatchRoute = (item: any) => {
    const seasonNumber = item?.seasonNumber || item?.tvSeasonNumber;
    return url.route('play', {
        id: btoa(item?.Id),
        guid: btoa(item?.guid),
        // Required for multi-season series: without season the player loads the first season
        // and falls back to that season's E1 instead of the tapped continue-watching tile.
        ...(seasonNumber ? { season: seasonNumber } : {}),
    });
};

export const transformDetailedBookmarks = (detailedBookmarks: any, bookmarks: any) => {
    return detailedBookmarks.map((asset: any) => {
        const bookmark = bookmarks?.find((bookmark) => bookmark.paId === asset.id || bookmark.assetid === asset.guid);
        return {
            ...asset,
            image_landscape: asset.images?.find((image) => image.type === 'cover')?.url,
            genre: asset.tags?.filter((tag) => tag.scheme === 'Genre').map((tag) => tag.title),
            ratings: asset.parentalRatings?.find((rating) => rating.scheme === 'urn:simple')?.rating,
            programType: asset?.subType,
            category: asset.programType,
            percentageNumber: asset?.duration > 0 ? ((asset?.timeCode || 0) / asset?.duration) * 100 : 0,
            textEn: asset?.programType === 'VOD' && asset?.subType === 'episode' ? asset?.seriesTitle : asset.title,
            textAr:
                asset?.programType === 'VOD' && asset?.subType === 'episode'
                    ? asset?.seriesLocalizedTitle?.ar
                    : asset?.titleLocalized?.ar,
            Id: asset.id,
            isBookmarked: !!bookmark,
            listing: asset?.listings.length > 0 ? asset?.listings[0] : null,
            mediaId: bookmark?.assetid,
        };
    });
};

const routeSubTypes: Record<string, string[]> = {
    [ROUTE_CONSTANT.MOVIES]: [PROGRAM_TYPE.MOVIE],
    [ROUTE_CONSTANT.SHOWS]: [PROGRAM_TYPE.SERIES, PROGRAM_TYPE.EPISODE],
};

export const filterAssetsByRoute = (assets: any[], screen: string) => {
    const allowedSubTypes = routeSubTypes[(screen || '').toLowerCase()];
    if (!allowedSubTypes) {
        return assets;
    }
    return assets.filter(
        (asset) =>
            (asset?.category || '').toUpperCase() !== 'LINEAR' &&
            allowedSubTypes.includes((asset?.programType || '').toLowerCase())
    );
};

export const getBookmarkDeletePayload = (asset: any) => {
    const isLinear = asset?.category === 'LINEAR' || asset?.programType === 'LINEAR';

    if (isLinear) {
        return {
            category: 'LINEAR',
            listingId: asset?.listingId ?? asset?.listing?.id ?? null,
            paId: asset?.paId ?? asset?.Id,
        };
    }
    return {
        category: 'VOD',
        mediaId: asset?.mediaId || null,
        Id: asset?.Id ?? asset?.id,
        paId: asset?.paId ?? asset?.Id ?? asset?.id,
    };
};
